import styled from "styled-components";

const BottomLinkStyled = styled.div`
  position: relative;
  width: 100%;
  padding: 2.4rem 1.6rem;
  border-top: ${props => props.theme.midGreyBorder};

  @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
    padding: 2.4rem 3.2rem;
  }

  a {
    color: ${props => props.theme.heritageGreen};
  }
`;

export { BottomLinkStyled };